import { focus } from '@dojo/framework/core/middleware/focus';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Tooltip } from '@dojo/widgets/tooltip';
import { Icon } from '@holmescorp/base-widgets';
import { createNlsMiddleware } from '@holmescorp/lcc-state';

import css from '../css/trigger.m.css';
import TocDrawer from './drawer';
import { TableOfContents } from './toc';

interface TocTriggerIcache {
	focusNode: string;
	open: boolean;
}

const icache = createICacheMiddleware<TocTriggerIcache>();

const factory = create({
	icache,
	nls: createNlsMiddleware('ditabook'),
	theme,
	focus
});

export const TocTrigger = factory(({ id: widgetId, middleware: { icache, nls, theme, focus } }) => {
	const {
		isPlaceholder,
		messages: { toc_open_tooltip = '[ditabook] toc_open_tooltip' }
	} = nls();

	if (isPlaceholder) {
		return null;
	}

	const focusNode = icache.getOrSet('focusNode', 'trigger');

	// const ttHover = () => {
	// 	icache.set('open', true);
	// };
	// const ttFocus = () => {
	// 	focus.focus();
	// 	icache.set('open', true);
	// };
	// const ttHidden = () => icache.set('open', false);

	const outIcon = w(Icon, {
		faname: 'angles-right',
		//		size: '2x',
		altText: toc_open_tooltip,
		xqa: 'slideout-open-icon',
		aria: { label: toc_open_tooltip }
	});

	const xqa = 'toc-trigger';
	const { root } = theme.classes(css);
	const open = icache.getOrSet('open', false);
	return v('div', { id: `${xqa}`, widgetId, xqa, classes: [theme.variant(), root] }, [
		w(Tooltip, { open, orientation: 'right' }, [
			{
				content: open ? null : toc_open_tooltip,
				trigger: v(
					'button',
					{
						aria: { expanded: open ? 'true' : 'false', label: toc_open_tooltip },
						key: 'trigger',
						focus: (): boolean => focusNode === 'trigger' && focus.shouldFocus(),
						onclick: (): void => {
							icache.set('focusNode', 'toc');
							icache.set('open', true);
						}
					},
					[!open ? outIcon : null]
				)
			}
		]),
		open &&
			w(
				TocDrawer,
				{
					key: 'toc',
					open,
					onClose: (): void => {
						icache.set('focusNode', 'trigger');
						focus.focus();
						icache.set('open', false);
					}
				},
				[w(TableOfContents, {})]
			)
	]);
});

export default TocTrigger;
